import { AuditLog, AuditType, IAuditLogFilterParams } from "@app/audit-log/models/audit-log-type.model";
import { createActionSet, createCrudActionSets, createNoPropsAction } from "@app/root-store/actions/action-creators";

import { ActionPayloadGeneric } from "@app/root-store/actions";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";

const auditLogTypeCategory = "Audit Log Type";

interface AuditLogTypeLoadActionResult {
    auditlogTypes: ClareDbCollection<AuditType>;
}

export const {
    request: loadType,
    success: loadTypeSuccess,
    failure: loadTypeFailure,
} = createActionSet<ActionPayloadGeneric, AuditLogTypeLoadActionResult>(auditLogTypeCategory, "Load");

/**
 * @description Used in the action creators to generate an action type like:
 * "[Audit Log Management] Load Audit Log"
 */
const auditLogCategory = "Audit Log";

/**
 * A payload used when performing an operation on a single audit log
 */
export type ActionPayload = ActionPayloadGeneric & {
    auditLog: AuditLog;
};

export interface LoadAuditLogSetPayLoad {
    params: IAuditLogFilterParams;
}

/**
 * An action result that returns a collection of entities
 */
export interface BulkActionResult {
    auditLogs: AuditLog[];
}

/**
 * An action result that returns a single entity
 */
export interface ActionResult {
    auditLog: AuditLog;
}

/**
 * Create the CRUD set of actions associated with the action category.
 * Must send in appropriate payload types for a single and load and result types for single and bulk.
 * A request, success and failure action are created for each CRUD operation.
 * Each action set should be deconstructed into consts from the result.
 */
export const {
    load: loadAuditLogSet,
    create: createLog,
    update: updateLog,
} = createCrudActionSets<ActionPayload, LoadAuditLogSetPayLoad, ActionResult, BulkActionResult>(auditLogCategory);

export const clearAuditState = createNoPropsAction(auditLogCategory, "Clear State");

export const clearAuditDataState = createNoPropsAction(auditLogCategory, "Clear Log Data State");
